// İSG uzmanı portalı — Risk Değerlendirme (Risk) TanStack Query anahtarları (api-contract §19,
// tenant-scoped). Liste anahtarı parametreleri içerir (filtre/sayfa değişince yeniden çeker);
// invalidasyon önek (prefix) ile yapılır: `['risk','list']` tüm liste sorgularını,
// `['risk','detail',uuid]` bir değerlendirmenin detayını (kalemler + DÖF dahil, hepsi tek
// `GET /risk-assessments/{uuid}` içinde) kapsar.
//
// İş İzni (§14) / Eğitim (§16) anahtarlarından AYRIDIR — Risk tek firmaya kapsanmış tenant iş
// modülüdür.

import type { RiskAssessmentListParams } from '@isgportal/shared';

export const riskKeys = {
  /** Tüm risk sorgularının kök öneki — invalidasyon için. */
  all: () => ['risk'] as const,
  /** Tüm liste sorgularının öneki (filtre/sayfa varyantlarını kapsar). */
  list: () => ['risk', 'list'] as const,
  /** Sayfalı + filtreli liste — parametreli. */
  listParams: (params: RiskAssessmentListParams) => ['risk', 'list', params] as const,
  /** Erişim sondası (gate) — hafif liste probu (page=1, pageSize=1). */
  access: () => ['risk', 'access'] as const,
  /** Tek değerlendirme detayı (kalemler + DÖF dahil). */
  detail: (uuid: string) => ['risk', 'detail', uuid] as const,
} as const;
